module.exports = __webpack_public_path__ + "static/media/cardBack.549bf9ef.svg";